import React from 'react';
import Styled from 'styled-components';

const SVG = Styled.svg`
  width: 18px;
  height: 18px;
  transform: rotate(180deg);

  circle {
    stroke-dashoffset: 0;
    transition: stroke-dashoffset 1s linear;
    stroke: #ababab;
    stroke-width: 2px;
  }
  
  #bar {
    stroke: #213E3D;
  }
`;

const ProgressIcon = ({ percentage }) => {
  const r = 8; // 10 - 2px for stroke
  const c = Math.PI * (r * 2);

  let val = percentage;
  if (val < 0) {
    val = 0;
  } else if (val > 100) {
    val = 100;
  }

  const offset = c - (val / 100) * c;

  return (
    <SVG viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <circle
        r={r}
        cx="10"
        cy="10"
        fill="transparent"
        strokeDasharray={`${c} ${c}`}
        strokeDashoffset="0"
      ></circle>
      <circle
        id="bar"
        r={r}
        cx="10"
        cy="10"
        fill="transparent"
        strokeDasharray={`${c} ${c}`}
        style={{ strokeDashoffset: offset }}
      ></circle>
    </SVG>
  );
};

export default ProgressIcon;
